import React from "react";
import TlkTable from "../tlelrik/table/tlkTable";
import services from "../../services";
import queryString from "query-string";
import ContaTabs from "./ContaTabs";
import { Button } from "@progress/kendo-react-buttons";
import TabsContaDetailsContainer from "./Tabs/TabsContaDetailsContainer";
import AcceptMovement from "./AcceptMovement";
import CreateDAA from "./CreateDAA";
import CreateIntroduzirRef from "./CreateIntroduzirRef";
var moment = require("moment");

// TODO: Rewrite component as per the movement listing in invision
// Ask @Dart for the same
const columnKeyMap = {
    // 'Movimento': 'Movimento',
    //dataCriado: "Data de criação",
    tipoMovimento: "Tipo de Movimento",
    operacao: "Operação",
    valorOperacao: "Quantidade (Litros)",
    acumuladoDisponivel: "Saldo Acumulado Disponível",
    saldoCativo: "Saldo Cativo",
    estadoMovimento: "Estado",
    numeroDocumento: "Nº Documento",
    descricao: "Descrição",
    dataOperacao: "Data Movimento",
    nomeEntidadeDestino: "Entidade Destino",
    //saldoPrevio: "Saldo Previo",
    
    //saldoFinal: "Saldo Final",

    // 'Detalhes do movimento': 'Detalhes do movimento'
};
const actionbuttons = { CommonRedirection: "Mov Aceitar", FillTransport: "Preencher Documento" , IntroduzirRef: "Introduzir referência do eDA" };
const groupfield = [];

const dateFormat = "DD-MM-YYYY HH:mm:ss";
class MovementListing extends React.Component {
    constructor() {
        super();

        this.state = {
            loaded: false,
            data: [],
            popUpForm: '',
            columnList: [],
            totalCount: 0,
            filters: {
                Filters: { entityId: null },
                FiltersIn: null,
                FiltersLike: null,
                SortBy: "",
                IsSortTypeDESC: true,
                IsPagination: false,
                Page: 2,
                PageSize: 2,
            },
        };
    }

    componentDidMount() {
        (async () => {
            const queryParams = queryString.parse(this.props.location.search);
            console.log("QPAR");
            console.log(queryParams);
            const filters = {
                ...this.state.filters,
                Filters: {
                    accountId: queryParams.accountId,
                    entityId: queryParams.entityId,
                },
            };
            const response = await services.apiCall.requestApi(
                "ContaCorrente/GetMovimentos",
                filters,
                "post"
            );
            // const columnList = Object.keys(columnKeyMap).map((key) => ({
            //     field: columnKeyMap[key],
            //     columnMenuType: "checkbox",
            // }));

            var columnList = [];

            Object.keys(columnKeyMap).forEach(e => {
                if(e == "valorOperacao" || e == "acumuladoDisponivel"){
                    columnList.push({field: columnKeyMap[e], columnMenuType: "number"});
                }
                else{
                    columnList.push({field: columnKeyMap[e], columnMenuType: "checkbox"});
                }
            });

            if (response) {
                // const data = response.map((entity) => ({
                //   ...Object.keys(columnKeyMap).reduce((acc, key) => {
                //     acc[columnKeyMap[key]] = entity[key]
                //     return acc;
                //   }, {}),
                //   selected: false,
                // }));
                console.log("arr length", response.length);
                console.log(response);
                const data = response.map((entity, index) => ({
                    ...entity,
                    ...Object.keys(columnKeyMap).map((key) => {
                        entity[columnKeyMap[key]] = entity[key];
                        // if(key === 'Movimento'){
                        //   entity[columnKeyMap[key]] = response.length-index
                        // }
                        if (key === "dataCriado") {
                            entity[columnKeyMap[key]] = entity["dataCriado"]
                                ? moment(entity["dataCriado"]).format(
                                      dateFormat
                                  )
                                : "nd";
                        }
                        if (key === "dataOperacao") {
                            entity[columnKeyMap[key]] = entity["dataOperacao"]
                                ? moment(entity["dataOperacao"]).format(
                                      dateFormat
                                  )
                                : "nd";
                        }
                        if (key === "dataMovimento") {
                            entity[columnKeyMap[key]] = entity["dataCriado"]
                                ? moment(entity["dataCriado"]).format(
                                      dateFormat
                                  )
                                : "nd";
                        }
                        if (key === "saldoCativo") {
                            entity["saldoCativo"] === 1 ? entity[columnKeyMap[key]] = "Sim" : entity[columnKeyMap[key]] = "Não";                             
                        }
                        if (key === "saldoFinal") {
                            entity[columnKeyMap[key]] = entity["saldoFinal"]
                                ? services.money.format(entity["saldoFinal"])
                                : 0;
                        }
                        if (key === "estado") {
                            entity[columnKeyMap[key]] = entity["estado"]
                                ? entity["estado"]
                                : "NA";
                        }
                        if (key === "nomeEntidadeDestino") {
                            entity[columnKeyMap[key]] = entity["nomeEntidadeDestino"]
                                ? entity["nomeEntidadeDestino"]
                                : "nd";
                        }
                        // if (key === "tipoMovimento") {
                        //     entity[columnKeyMap[key]] = entity["descricaoTipo"];
                        // }
                        // if (key === "saldoPrevio") {
                        //     entity[columnKeyMap[key]] = entity["saldoPrevio"]
                        //         ? services.money.format(entity["saldoPrevio"])
                        //         : 0;
                        // }
                        if (key === "valorOperacao"){
                            entity[columnKeyMap[key]] = entity["valorOperacao"]
                            ? services.money.format(entity["valorOperacao"])
                            : 0;
                        }
                        if (key === "acumuladoDisponivel"){
                            entity[columnKeyMap[key]] = entity["acumuladoDisponivel"]
                            ? services.money.format(entity["acumuladoDisponivel"])
                            : 0;
                        }
                    }),
                    selected: false,
                }));
                let accountTotal;
                if (data) {
                    accountTotal =
                        data && data.length > 0 && data[0]["saldo"]
                            ? services.money.format(data[0]["saldo"])
                            : 0;
                } else accountTotal = 0;
                this.setState(() => ({
                    data,
                    columnList,
                    totalCount: window.localStorage.getItem("table_total"),
                    loaded: true,
                    accountTotal,
                }));
            } else {
                this.setState(() => ({
                    data: response,
                    totalCount: 0,
                    columnList,
                    loaded: false,
                }));
            }
        })();
        this.accountDetailsToPass();
    }

    entityDetailData = (data) => {
        this.setState({ entityDetail: data })
    }

    accountDetailsToPass = () => {
        const params = queryString.parse(this.props.location.search);
        console.log("params9999 ", params);
        let accountDetails = {};
        accountDetails["accountNumber"] = params.ncc || "NA";
        accountDetails["accounttype"] = params.tdc || "NA";
        accountDetails["accountProduct"] = params.pr || "NA";
        accountDetails["saldoGranel"] = params.sldG || "NA";
        accountDetails["saldoApto"] = params.sldA || "NA";
        accountDetails["saldoEngarrafado"] = params.sldE || "NA";
        accountDetails["accountTotal"] = params.sa || "NA";
        accountDetails["tipoConta"] = params.tdc || "NA";
        return accountDetails;
    };

    getToolbarHtml() {
        const params = queryString.parse(this.props.location.search);
        const { accountTotal } = this.state;
        return (
            <>
                <span className="pr-3">
                    Nº Conta Corrente: {params.ncc || "nd"}
                </span>
                <span className="px-3 border-left">
                    Tipo de Conta: {params.tdc || "nd"}
                </span>
                <span className="px-3 border-left">
                    Produto: {params.pr || "nd"}
                </span>
                <span className="px-3 border-left">
                    Saldo Atual: {accountTotal}
                </span>
            </>
        );
    }

    ActionPerform = async (action, row) => {
        if (action === "acceptMovement") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <AcceptMovement
                    instalacaoVinica={this.state.entityDetail.wineInhalation}
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "fillTransport") {
            this.setState({
                popUpForm: ""
            })
            console.log(row);
            console.log(row["Quantidade (Litros)"]);
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateDAA
                    instalacaoVinica={this.state.entityDetail.wineInhalation}
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }
        else if (action === "IntroduzirRef") {
            this.setState({
                popUpForm: ""
            })
            const params = queryString.parse(this.props.location.search);
            let popUpForm = (
                <CreateIntroduzirRef
                    instalacaoVinica={this.state.entityDetail.wineInhalation}
                    tipoConta={params.tdc}
                    produto={params.pr}
                    quantidade={row["Quantidade (Litros)"]}
                    tipoMovimento={row["Tipo de Movimento"]}
                    entidade={row["Entidade Destino"]}
                    idContaCorrente={params.accountId}
                    qtdNum={row.valorOperacao}
                    idTipoMovimento={row.idTipoMovimento}
                    idContaCorrenteMovimento={row.idContaCorrenteMovimento}
                />
            )
            this.setState({
                popUpForm
            })
        }


    };

    render() {
        return (
            <>
                <div className="mt-4">
                <TabsContaDetailsContainer 
                accountDetails={this.accountDetailsToPass()}
                location={this.props.location}
                match={this.props.match}
                entityDetailData={(data) => this.entityDetailData(data)}
                />
                    <div className="table-section custom-k-grid pt-3">
                        <div className="table-responsive">
                            {this.state.loaded && (
                                <>
                                    <span>
                                        A pesquisa retornou{" "}
                                        {this.state.totalCount} registos
                                    </span>
                                    <TlkTable
                                        date={new Date()}
                                        list={this.state.data}
                                        modulename={"Conta Corrente"}
                                        //notAction={true}
                                        //viewFor="conta_movimento"
                                        // notGroup={true}
                                        //collepsview={true}
                                        columnlist={this.state.columnList}
                                        actionbuttons={actionbuttons}
                                        ActionPerform={(action, id) =>
                                            this.ActionPerform(action, id)
                                        }
                                        //fixTableWidth={true}
                                        groupfield={groupfield}
                                        //toolbarHTML={ this.getToolbarHtml() }
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
                <div className="modal left-popup" id="accept-mov-left-popup">
                    <div className="modal-dialog modal-sm">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>
            </>
        );
    }
}

export default MovementListing;
